<template>
  <div class="error">
    <img class="error_img" :src="img.error">
    <div class="error_text">抱歉，你所访问的网页不存在了，请返回主页</div>
    <div class="gohome_text" @click="goHome">返回首页</div>
  </div>
</template>
<script>
  import post from '../../../api/lexus/release';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon } from 'vant';
  export default {
    data () {
      return {
        img:{
          error: require('../../../assets/img/error.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })

    },
    methods: {
      goHome(){
        this.$router.push({name:'Home'});
      }
    },
    
  }
</script>
<style lang="scss">
  .error{
    margin-top: 200px;
    text-align: center;
    .error_img{
      width: 122px;
      height: 94px;
    }
    .error_text{
      font-size: 16px;
      color: #eaeaea;
      margin-top: 30px;
      font-weight: bold;
    }
    .gohome_text{
      font-size: 16px;
      color: #f5bc41;
      margin-top: 30px;
      font-weight: bold;
      cursor: pointer;
    }
  }
</style>
